// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__XFoB4","header":"MessagesList_header___IDZD","chat":"MessagesList_chat__aR4ID"};